module.exports = __webpack_public_path__ + "sy.svg?d648066bba18b3fedf66db0fca2da5ff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/sy.svg
// module id = 1377
// module chunks = 0